var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('status-alert',{attrs:{"color":_vm.statusColor,"shown":_vm.statusShown},on:{"update:shown":function($event){_vm.statusShown=$event}}},[_vm._v(" "+_vm._s(_vm.statusMessage)+" ")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }